import React, { useState, useEffect } from 'react';
import getFacility from '../../shared/api/getFacility';
import ChangeMailParams from '../types/ChangeMailParams';
import changeMail from '../api/changeMail';

const Main: React.FC = () => {
  const [facilityCode, setFacilityCode] = useState("");
  const [email, setEmail] = useState<string>("");
  const [emailConfirmation, setEmailConfirmation] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [passwordConfirmation, setPasswordConfirmation] = useState<string>("");
  const [alertMessageOpen, setAlertMessageOpen] = useState<boolean>(false)
  const [alertMessages, setAlertMessages] = useState<string[]>([])
  const [isCompleted, setCompleted] = useState<boolean>(false)

  useEffect(() => {
    const fetchFacility = async () => {
      try {
        const response = await getFacility();
        setFacilityCode(response.data.facility.uid);
      } catch (error) {
        console.error("Error fetching facility data:", error);
      }
    };

    fetchFacility();
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const params: ChangeMailParams = {
      email: email,
      email_confirmation: emailConfirmation,
      password: password,
      password_confirmation: passwordConfirmation
    }

    try {
      await changeMail(facilityCode, params);
      setAlertMessageOpen(false);
      setCompleted(true);
    } catch (err: any) {
      setAlertMessageOpen(true);
      setCompleted(false);

      console.log(err);
      // err.responseが存在し、かつerr.response.dataが存在する場合
      if (err.response && err.response.data && err.response.data.errors) {
        setAlertMessageOpen(true);
        setAlertMessages(err.response.data.errors);
      } else {
        // 予期せぬエラーの場合の処理
        setAlertMessageOpen(false);
        console.log('An unexpected error occurred:', err);
      }
    }
  }

  const messages = alertMessages.length === 0 ? '' : alertMessages.map((message: string) =>
    <li>{message}</li>
  );

  const form = (
    <main id="page-facility_login" className="wrapper">
      <section className="sec-contact">
        <div className="inner">
          <h1 className="c-ttl__01">メールアドレス・パスワードの変更</h1>
          { alertMessageOpen &&
            <div className="contact-note" style={{marginTop: '20px', marginBottom: '0px'}}>
              <ul>
                { messages }
              </ul>
            </div>
          }
          <div className="contact-box">
            <div className="contact-box__left">
              <form onSubmit={handleSubmit}>
                <div className="contact-box__form js-item" id="id-01">
                  <div className="contact-box__item">
                    <label className="contact-box__ttl">
                      <span>メールアドレス</span>
                      <small>必須</small>
                    </label>
                    <div className="contact-box__ct">
                      <input name="email" type="text" className="input" placeholder="test@example.com" onChange={ event => setEmail(event.target.value) } />
                    </div>
                  </div>
                  <div className="contact-box__item">
                    <label className="contact-box__ttl">
                      <span>メールアドレス(確認)</span>
                      <small>必須</small>
                    </label>
                    <div className="contact-box__ct">
                      <input name="email_confirmation" type="text" className="input" placeholder="test@example.com" onChange={ event => setEmailConfirmation(event.target.value) } />
                    </div>
                  </div>
                  <div className="contact-box__item">
                    <label className="contact-box__ttl">
                      <span>パスワード変更</span>
                      <small>必須</small>
                    </label>
                    <div className="contact-box__ct">
                      <input name="password" type="password" className="input input--pw" placeholder="*********" onChange={ event => setPassword(event.target.value) } />
                    </div>
                  </div>
                  <div className="contact-box__item mbpc-20 mbsp-20">
                    <label className="contact-box__ttl">
                      <span>パスワード(確認)</span>
                      <small>必須</small>
                    </label>
                    <div className="contact-box__ct">
                      <input name="password_confirmation" type="password" className="input input--pw" placeholder="*********" onChange={ event => setPasswordConfirmation(event.target.value) } />
                    </div>
                  </div>
                  <p className="c-ttl__02"><span>※パスワードは半角数字、半角記号、半角英大文字、半角英小文字から3種類以上を含む8文字以上で入力してください。</span></p>
                </div>
                <button type="submit" className="c-btn__01">登録</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
  );

  const completed = (
    <main id="page-facility_login" className="wrapper">
      <section className="sec-contact">
        <div className="inner">
          <h1 className="c-ttl__01">メールアドレス・パスワードの変更完了</h1>
        </div>
      </section>

      <div className="sec-link">
        <div className="inner">
          <div className="link-block">
            <p className="c-txt__01 c-al--c">メールアドレス・パスワードの変更が完了しました。</p>
            <a href="/facility/top" className="c-btn__01 c-btn__01--white">TOPページに戻る</a>
          </div>
        </div>
      </div>
    </main>
  );

  return (
    <React.Fragment>
      { isCompleted ? completed : form }
    </React.Fragment>
  );
}

export default Main;
